import { WizGroupCommand } from './wiz-group-command';
import { Injectable } from '@angular/core';
import { WizCommand } from './wiz-command';
import { WizInitTranslationCommand } from './wiz-init-translation.command';

/**
 * Application initialization group command called by wizModule through APP_INITALIZER
 */
@Injectable()
export class WizInitGroupCommand extends WizGroupCommand {

    constructor() {
        super();
    }

    public async execute() {
        this.configure(this.initCommands, null, false);
        return super.execute();
    }

    /**
     * Commands included
     */
    protected get initCommands(): WizCommand<any>[] {
        return [new WizInitTranslationCommand(null, 'en')];
    }
}